import React from 'react';
import { useActiveEvent } from '../../hooks/useActiveEvent';
import EventStatsWidget from './EventStatsWidget';
import EventLeaderboard from './EventLeaderboard';

function formatEventRange(event) {
  if (!event?.starts_at || !event?.ends_at) {
    return '';
  }

  const start = new Date(String(event.starts_at).replace(' ', 'T'));
  const end = new Date(String(event.ends_at).replace(' ', 'T'));
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return '';
  }

  return `${start.toLocaleDateString('de-DE')} bis ${end.toLocaleDateString('de-DE')}`;
}

export function EventChallengeBanner({ position = null, compact = false }) {
  const { event, stats, leaderboard, loading } = useActiveEvent(position);

  if (loading || !event) {
    return null;
  }

  return (
    <section className={`pfp-event-banner ${compact ? 'pfp-event-banner--compact' : ''}`}>
      <div className="pfp-event-banner__copy">
        <span className="pfp-event-kicker">Aktive Challenge</span>
        <h2>{event.title}</h2>
        {event.description ? <p>{event.description}</p> : null}
        <div className="pfp-event-banner__meta">
          {formatEventRange(event) ? <span>{formatEventRange(event)}</span> : null}
          {event.radius_meters ? <span>{Number(event.radius_meters).toLocaleString('de-DE')} m Radius</span> : null}
        </div>
        <div className="pfp-event-banner__actions">
          <a className="pfp-event-button" href="#/quick-mark">Fund melden</a>
          <a className="pfp-event-button pfp-event-button--secondary" href="#/events">Rangliste</a>
          <a className="pfp-event-button pfp-event-button--ghost" href="#/map">Karte</a>
        </div>
      </div>
      <div className="pfp-event-banner__side">
        <EventStatsWidget stats={stats} />
        {!compact ? <EventLeaderboard rows={leaderboard} compact /> : null}
      </div>
    </section>
  );
}

export default EventChallengeBanner;
